export const Bio = {
    name: "Wan Haziq Iskandar",
    roles: [
      "Backend Developer",
      "Frontend Developer",
      "Software Engineer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/wanhaziqiskandar",
    resume: "https://drive.google.com/file/d/1QOGSGa9GLLAL3lCFdu0XCey4zjzqGAz2/view?usp=drive_link",
    linkedin: "https://www.linkedin.com/in/wan-haziq-iskandar-wan-izhan-2a354b286/",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        // {
        //   name: "Next Js",
        //   image:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        // },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: ".NET",
          image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Microsoft_.NET_logo.svg/684px-Microsoft_.NET_logo.svg.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "C++",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg"
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "PHP",
          image: "https://www.svgrepo.com/show/303656/php-logo.svg",
        },
        {
          name: "Laravel",
          image: "https://cdn.worldvectorlogo.com/logos/laravel-2.svg",
        },
        {
          name: "Airflow DAGs",
          image:
            "https://miro.medium.com/v2/resize:fit:828/format:webp/1*BEGGWVM2rQx438Fevmz1Fw.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        // {
        //   name: "Git",
        //   image:
        //     "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
        // },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://seeklogo.com/images/P/postman-logo-0087CA0D15-seeklogo.com.png",
        },
        {
          name: "Figma",
          image:
            // "https://www.iconfinder.com/icons/7564187/figma_logo_brand_icon.png",
            "https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/3000/figma-logo-512.png"
        },
       
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 1,
      company: 'Telekom Malaysia Research and Development',
      role: 'Software Engineer Intern',
      desc: 'Working as a Backend Developer Intern on revamping an old system by converting legacy Bash scripts into Python. This involves integrating the new scripts into Apache Airflow DAGs for better automation and scheduling, facilitating a smoother migration process.',
      date: 'Date: July 2024 - September 2024',
      skills: ['Docker', 'Python', 'Airflow', 'VSCode'],
      logo: 'https://upload.wikimedia.org/wikipedia/commons/6/68/TM_Research_and_Development_Logo.png', // Add company logo here
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://upload.wikimedia.org/wikipedia/ms/3/38/Sekolah_Menengah_Kebangsaan_Saujana_Impian.jpg",
      school: "Sekolah Menengah Saujana Impian, Kajang, Selangor",
      date: "January 2015 - December 2019",
      grade: "SPM 2A, 3B+, 2B, 2C",
    },
    {
      id: 1,
      img: "https://upload.wikimedia.org/wikipedia/en/3/31/International_Islamic_University_Malaysia_emblem.svg",
      school: "International Islamic University Malaysia",
      date: "August 2020 - November 2021",
      grade: "3.62",
      foundation: "Foundation of Engineering and Computer Science"
    },
    {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/commons/b/bc/Universiti_Tenaga_Nasional_Logo.png",
      school: "Universiti Tenaga Nasional",
      date: "February 2022 - January 2025",
      grade: "3.68",
      degree: "Bachelor Degree in Computer Science (Software Engineering)",
    },

    
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Rural Library Management System",
      description:
        "Developed a web-based platform with self-registration functionality and automated event information management, eliminating paper-based processes and improving overall efficiency",
      tags: [
       "HTML",
        "CSS",
        "PHP",
        "MySQL",
        "Bootstrap",
        "Laravel",
      ],
      category: "web app",
      github: "https://github.com/wanhaziqiskandar/FinalProject",
    },
    {
      id: 1,
      title: "E-Portfolio",
      description:
        "A dynamic web application designed to help users create, customize, and showcase their portfolios online. Built with React, JavaScript, and CSS, this application offers a user-friendly interface for displaying personal and professional work. Users can easily share their portfolios and present their skills and achievements effectively. Check out the project's code on GitHub for more details and contributions.",
      tags: [
       "ReactJs",
        "JavaScript",
        "CSS",
      ],
      category: "web app",
      github: "https://github.com/wanhaziqiskandar/eportfolio",
    },
  ];